import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "upload-button-area" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-icon_tianjia" }),
  /*#__PURE__*/_createElementVNode("span", null, "上传封面")
], -1)

import { verification } from "@/../../shared-common/src/util/verification";
import _ from "lodash";
import { reactive, getCurrentInstance, ref } from "vue";
import {ElMessage, UploadProps} from "element-plus";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { proxy } = getCurrentInstance() as any;
const validateImage = (rule: any, value: any, callback: any) => {
  if (!value || !value.length) {
    callback(new Error("请上传图片"));
  } else {
    callback();
  }
};

const beforeUpload: UploadProps['beforeUpload'] = (rawFile) => {
  if (rawFile.type === "image/jpeg" || rawFile.type === "image/png") {
    if (rawFile.size / 1024 / 1024 > 10) {
      ElMessage.error("图片大小需要小于 10M!");
      return false;
    }
  }
  return true;
};
const validateUrl = (rule: any, value: any, callback: any) => {
  if (!state.form.url) {
    callback(new Error("请输入地址"));
  } else if (!verification.checkUrl.test(state.form.url)) {
    callback(new Error("请输入合法的地址"));
  } else {
    callback();
  }
};
const masFormMainRef = ref<any>(null);
const masUploadRef = ref<any>(null);
const state: any = reactive({
  uploadAccept: ".jpg,.png",
  dialog: false,
  title: "",

  form: {
    enclosureId: "",
    title: "",
    url: "",
    desc: "",
    list: [],
  },
  ruleForm: {
    title: [{ required: true, message: "请输入链接标题", trigger: "blur" }],
    url: [{ required: true, validator: validateUrl, trigger: "blur" }],
    list: [{ required: true, validator: validateImage, trigger: "change" }],
  },
  type: "link",
});
const active = (res: any, type: number) => {
  state.dialog = true;
  state.title = `${type === 1 ? "添加" : "编辑"}链接`;
  // id作为是否编辑的依据
  if (!res.enclosureId) {
    setTimeout(() => {
      state.form = { ...res };
      state.form.resourceId = "";
      masFormMainRef.value._resetForm();
    }, 50);
  } else {
    setTimeout(() => {
      state.form = { ...res };
      state.form.list = [{
        response: {
          data: {
            id: res.resourceId
          }
        }
      }]
      masUploadRef.value.setFileList(res);
    }, 100);
  }
};
const remove = () => {
  state.form.list = [];
};
const confimForm = (res: any) => {
  state.dialog = false;
  state.form.name = "链接";
  state.form.enclosureId = state.form.enclosureId;
  let linkData = [
    {
      ...state.form,
    },
  ];
  proxy.$emit("updateSuccess", linkData, state.type);
};
expose({
  active,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_mas_upload = _resolveComponent("mas-upload")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_mas_modal = _resolveComponent("mas-modal")!

  return (_openBlock(), _createBlock(_component_mas_modal, {
    visible: _unref(state).dialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).dialog) = $event)),
    customFooterBtns: "",
    closeIcon: "",
    width: "600px",
    title: _unref(state).title
  }, {
    content: _withCtx(() => [
      _createVNode(_component_mas_form_main, {
        ref_key: "masFormMainRef",
        ref: masFormMainRef,
        labelPosition: "right",
        form: _unref(state).form,
        ruleForm: _unref(state).ruleForm,
        defaultFormFooterButton: ['confirm', 'cancel'],
        onConfim: confimForm,
        labelWidth: "100px",
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).dialog = false))
      }, {
        content: _withCtx((slotProps) => [
          _createVNode(_component_el_form_item, {
            label: "链接标题",
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入链接标题",
                maxlength: "100",
                modelValue: slotProps.content.title,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.title) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "链接摘要",
            prop: "desc"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入链接摘要",
                modelValue: slotProps.content.desc,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.desc) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "链接地址",
            prop: "url"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入链接地址",
                modelValue: slotProps.content.url,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.url) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "封面",
            prop: "list",
            style: {"width":"calc(100% - 100px)"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_mas_upload, {
                ref_key: "masUploadRef",
                ref: masUploadRef,
                accept: _unref(state).uploadAccept,
                customCon: true,
                value: slotProps.content.list,
                "onUpdate:value": ($event: any) => ((slotProps.content.list) = $event),
                onRemove: remove,
                action: `/api/resource/upload?type=image`,
                drag: true,
                "before-upload": beforeUpload,
                tip: "建议图片为 jpg/png 格式，大小在10M以内"
              }, {
                content: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 2
              }, 1032, ["accept", "value", "onUpdate:value"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["form", "ruleForm"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})